
class ClassHelper {

    dropdownStyleSmall() {
        return {
            valueContainer: (provided) => ({
                ...provided,
                minWidth: '50px'
            }),
        }
    }

    dropdownStyleLarge() {
        return {
            valueContainer: (provided) => ({
                ...provided,
                minWidth: '160px'
            })
        }
    }

    dropdownStyleMedium() {
        return {
            valueContainer: (provided) => ({
                ...provided,
                minWidth: '100px'
            })
        }
    }

    dropdownCreateForm() {
        return {
            control: (provided) => ({
                ...provided,
                minHeight: '25px',
                height: '32px'
            }),
            valueContainer: (provided) => ({
                ...provided,
                height: '32px',
                minWidth: '260px'
            }),
            indicatorsContainer: (provided) => ({
                ...provided,
                height: '32px',
            }),
        }
    }

    dropdownStyleSmallMenu() {
        return {
            menu: ({ width, ...css }) => ({ ...css }),
            control: (css) => ({ ...css, 
                display: "inline-flex ",
                width: '100%' }),
            valueContainer: (css) => ({
                ...css,
                minWidth: '60px'
            })
        }
    }
    
    dropdownStyleLargeMenu() {
        return {
            menu: ({ width, ...css }) => ({ ...css }),
            control: (css) => ({ ...css, display: "inline-flex " }),
            valueContainer: (css) => ({
                ...css,
                minWidth: '200px'
            })
        }
    }
}

export default new ClassHelper();